import { requestV2 } from './request'
import { findRegionByLocale } from '@/common/region-locale'

export type AboutUsData = {
  topBannerPicUrl: string
  topBannerPicH5Url: string
  topBannerMediaUrl: string
  aboutPuduTitle: string
  aboutPuduContent: string
  companyProfile?: Array<{
    label: string
    value: string
  }>
  globalLayout: {
    title: string
    titleDesc: Array<{
      title: string
      desc: string
    }>
    location: {
      backgroudUrl: string
      locationItem: Array<{
        title: string
        desc: string
        startX: number
        startY: number
        endX: number
        endY: number
      }>
      productMediaUrl: string
      locationDescList: Array<{
        titleTop: string
        titleMiddle: string
        descBottom: string
      }>
    }
    bottomTitle: string
  }
  devHistoryTitle: string
  devHistory: Array<{
    year: string
    mediaUrl: string
    monthDesc: Array<{
      title: string
      desc: string
    }>
  }>
  corporateCulture: {
    title: string
    items: Array<{
      title: string
      desc: string
    }>
    mediaUrls: string[]
    icons: Array<{
      title: string
      mediaUrl: string
    }>
  }
  brandHonor: {
    title: string
    items: Array<{
      title: string
      mediaUrl: string
    }>
  }
  bottomRemark: Array<{
    title: string
    desc: string
  }>
  tabTitle: string
}

export async function getAboutUs(locale: string): Promise<AboutUsData> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2('/aboutUs', params)
  if (process.env.NODE_ENV === 'development') {
    console.log('[getAboutUs] response:', {
      locale,
      region: params.region,
      data: res,
    })
  }
  return res
}
